import Vue from "vue";
import VueRouter from "vue-router";
import ConsultaLiquidacion from "@/components/liquidacion/Consulta.vue";
import Pagos from "@/components/Pagos.vue";
import PagosDetalle from "@/components/PagosDetalle.vue";
import Login from "@/components/login/Login.vue";
import Home from "@/components/Home.vue";
import PlanillaLista from "@/views/PlanillaLista";
import Planilla from "@/views/Planilla";
import Macheo from "@/views/Macheo";
import SolicitudesUsuarioWeb from "@/views/SolicitudesUsuarioWeb";
import ConsultaObras from "@/components/obras/ConsultaObras.vue";
import ConsultaPersonas from "@/components/personas/ConsultaPersonas.vue";
import ConsultaOrdenPago from "@/components/ordenPago/ConsultaOrdenPago.vue";
import Distribucion from "@/views/Distribucion.vue";
import Bmat from "@/views/Bmat.vue";
import Rbt from "@/views/Rbt.vue";
import Bolsa from "@/views/Bolsa.vue";
import Reparto from "@/components/distribucion/Reparto.vue";
import Migracion from "@/components/migracion/Migracion.vue";
import ConsultaPagosGeneracion from "@/views/ConsultaPagosGeneracion.vue"
import Kits from "@/views/Kits.vue"
import AsistenciaSocio  from "@/views/eventosSociales/AsistenciaSocio.vue"
import TableroEventos  from "@/views/eventosSociales/Tablero.vue"
import ReporteCheque from "@/components/cheque/ReporteCheque.vue";
import Cumpleanos from "../components/cumpleanos/Cumpleanos.vue";
import Censo from "../views/Censo.vue"
import Crd from "../views/Crd.vue"
import ConsultaCrd from "../components/crd/ConsultaCrd.vue"

import store from "../store";
import ConsultaExpediente from "../components/expedientes/ConsultaExpediente.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/liquidacion",
    component: ConsultaLiquidacion,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("LIQUIDACION")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },

  { path: "/login", component: Login },

  {
    path: "/pago",
    component: Pagos,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("PAGO")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/pago/:id",
    component: PagosDetalle,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("PAGO")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/planillas",
    component: PlanillaLista,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("PLANILLA")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/planilla",
    component: Planilla,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("PLANILLA")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },

  {
    path: "/planilla/:id",
    component: Planilla,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("PLANILLA")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/solicitudesUsuarioWeb",
    component: SolicitudesUsuarioWeb,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("USUARIOSWEB")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/consultaObras",
    component: ConsultaObras,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("CONSULTAOBRAS")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/macheo",
    component: Macheo,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("CONSULTAOBRAS")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },  
  {
    path: "/distribucion",
    component: Distribucion,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("DISTRIBUCION")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/reparto",
    component: Reparto,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("DISTRIBUCION")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  }, 
  {
    path: "/migracion",
    component: Migracion,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("MIGRACION")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },  
  {
    path: "/consultaPersonas",
    component: ConsultaPersonas,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("CONSULTAPERSONAS")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/consultaOrdenPago",
    component: ConsultaOrdenPago,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("CONSULTAPERSONAS")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/consultaPagosGeneracion",
    component: ConsultaPagosGeneracion,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("CONSULTAPAGOS")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/bmat",
    component: Bmat,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("BMAT")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/bolsa",
    component: Bolsa,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("BMAT")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/rbt",
    component: Rbt,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("RBT")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/kits",
    component: Kits,
    beforeEnter(to, from, next) {
      // if (store.getters.user) {
      //   if (store.getters.user.roles.includes("KITS")) {
      //     next();
      //   } else {
      //     next("/");
      //   }
      // } else {
      //   next("/login");
      // }

      next();
    }
  },
  {
    path: "/asistenciaSocio",
    component: AsistenciaSocio,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("EVENTOS_SOCIALES_TABLERO")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/tableroEventos",
    component: TableroEventos,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("EVENTOS_SOCIALES_TABLERO")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/reporteCheque",
    component: ReporteCheque,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("PAGO")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/cumpleanos",
    component: Cumpleanos,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("SOCIAL")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/expediente",
    component: ConsultaExpediente,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("SOCIAL")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/censo",
    component: Censo,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("CENSO")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/crd",
    component: Crd,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("DISTRIBUCION")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/consultaCrd",
    component: ConsultaCrd,
    beforeEnter(to, from, next) {
      if (store.getters.user) {
        if (store.getters.user.roles.includes("DISTRIBUCION")) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/login");
      }
    }
  },
  
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
